import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Browser } from '@capacitor/browser';

import { ExternalLinkIcon, InfoBaseIcon } from '../../icons';

import {
	NameChangeNoteRoot,
	NoteBox,
	NoteIcon,
	NoteText,
	SupportButton,
} from './NameChangeNote.styles';

const CONTACTS_FORM_LINK = 'https://www.mopla.solutions/de/unternehmen/kontakt';

/**
 * Note shown in the passenger profile "Personal details" form explaining that
 * the name fields are disabled and cannot be changed in the app, with a link to
 * contact support. Rendered directly under the (disabled) name fields.
 */
export const NameChangeNote: FC = () => {
	const { t } = useTranslation('personalDetails');

	const openSupport = () => {
		Browser.open({ url: CONTACTS_FORM_LINK });
	};

	return (
		<NameChangeNoteRoot data-testid="personal-detailsForm-nameChange-note">
			<NoteBox>
				<NoteIcon>
					<InfoBaseIcon />
				</NoteIcon>
				<NoteText>{t('text.name_change_not_possible')}</NoteText>
			</NoteBox>
			<SupportButton
				variant="text"
				endIcon={<ExternalLinkIcon />}
				onClick={openSupport}
				testId="personal-detailsForm-nameChange-supportButton"
			>
				{t('button.contact_support')}
			</SupportButton>
		</NameChangeNoteRoot>
	);
};
